export const apiHeadersType = {
  jsonType: 'application/json',
};
export const api_url = process.env.REACT_APP_SELF_API_URL || '';
export const casUrl = process.env.REACT_APP_CAS_URL || '';
export const cas_api_url = process.env.REACT_APP_CAS_API_URL || '';
export const cas_login_url = process.env.REACT_APP_CAS_LOGIN_URL || '';
export const img_url = 'https://storage.googleapis.com/dentaltw-storage/images';
export const url = process.env.REACT_APP_SELF_URL || window.location.origin;
export const landingPageUrl = 'https://dentallio.github.io/baru-landing';
export const session_domain = process.env.REACT_APP_SESSION_DOMAIN || '';
export const wsUrl = process.env.REACT_APP_SHEETA_URL || '';
